export { default } from './BestsellerSliderBlock'
